import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterApoios() {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/apoios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDisponiveis() {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/apoios/disponiveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirApoios(apoios) {
        return axiosJwt
            .post(`${api}/sgtec/gerentes/apoios`, apoios)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirApoios(apoioId) {
        return axiosJwt
            .delete(`${api}/sgtec/gerentes/apoios/${apoioId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
